webpackJsonp([8],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_posts__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_albums__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_users__ = __webpack_require__(162);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* state */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* mutations */],
  modules: {
    posts: __WEBPACK_IMPORTED_MODULE_6__modules_posts__["a" /* default */],
    albums: __WEBPACK_IMPORTED_MODULE_7__modules_albums__["a" /* default */],
    users: __WEBPACK_IMPORTED_MODULE_8__modules_users__["a" /* default */]
  }
}));

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(226)
}
var Component = __webpack_require__(61)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(240),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(227)
}
var Component = __webpack_require__(61)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(241),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var request = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://wg.xkejia.cn/",
  timeout: 50000
});

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(function (config) {
  config.headers['Content-Type'] = 'application/json;charset=utf-8';
  config.headers['Authorization'] = '';
  config.headers['Platform'] = 'ZHGWPT';
  config.headers['Identifier'] = 'QJTYBS';
  config.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    global: {
      ip: '',
      pip: '',
      os: 2,
      sign: '',
      token: localStorage.getItem('accessToken'),
      timestamp: 0,
      version: '',
      imei: '',
      dataSource: 15,
      langueType: 1
    }
  }, config.data);
  // config.headers['token'] = user.token;  // 设置请求头
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(function (response) {
  var res = response.data;
  // 如果是返回的文件
  if (response.config.responseType === 'blob') {
    return res;
  }
  // 兼容服务端返回的字符串数据
  if (typeof res === 'string') {
    if (response.config.isStr) {
      return res;
    }
    res = res ? JSON.parse(res) : res;
  }
  return res;
}, function (error) {
  console.log('err' + error); // for debug
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (request);

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ClipLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '35px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size,
        width: this.size,
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: this.color + ' ' + this.color + ' transparent',
        borderRadius: this.radius,
        background: 'transparent !important'
      };
    }
  }
});

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App'
});

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_lazyload__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_muse_ui_dist_muse_ui_css__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_muse_ui_dist_muse_ui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_muse_ui_dist_muse_ui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_muse_ui_dist_theme_light_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_muse_ui_dist_theme_light_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_muse_ui_dist_theme_light_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_reset_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_common_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_css_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_amfe_flexible__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_amfe_flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_amfe_flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_rem_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_rem_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__libs_rem_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vconsole__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vconsole___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vconsole__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// import MuseUI from 'muse-ui';












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ClipLoader', __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_ClipLoader_vue___default.a);
// 引入museUI && lazyload
// Vue.use(MuseUI);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_lazyload___default.a, {
  loading: 'static/load.gif'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui___default.a);
/* eslint-disable no-new */

var vConsole = new __WEBPACK_IMPORTED_MODULE_14_vconsole___default.a();
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a },
  template: '<App/>'
});

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doSpinner", function() { return doSpinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetSpinner", function() { return resetSpinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(19);


var doSpinner = function doSpinner(_ref, showSpinner) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["m" /* SAVE_SHOWSPINNER */], showSpinner);
};

var resetSpinner = function resetSpinner(_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["n" /* RESET_SHOWSPINNER */]);
};

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSpinner", function() { return isSpinner; });
var isSpinner = function isSpinner(state) {
  return state.showSpinner;
};

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_jsonholder__ = __webpack_require__(40);


var _mutations;




// initial state
var state = {
  albumsList: [],
  albumDetail: []
};

// getters
var getters = {
  allAlbums: function allAlbums(state) {
    return state.albumsList;
  },
  albumDetail: function albumDetail(state) {
    return state.albumDetail;
  }
};

// actions
var actions = {
  getAlbums: function getAlbums(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    __WEBPACK_IMPORTED_MODULE_2__services_jsonholder__["f" /* getAlbums */]().then(function (res) {
      var albumsList = res.data.data;
      // console.log(albumsList)
      var showSpinner = false;
      dispatch('doSpinner', showSpinner, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* SAVE_ALBULMS_LIST */], { albumsList: albumsList });
    });
  },
  getAlbumDetail: function getAlbumDetail(_ref2, albumId) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    __WEBPACK_IMPORTED_MODULE_2__services_jsonholder__["g" /* getAlbumDetail */](albumId).then(function (res) {
      var albumDetail = res.data.data;
      var showSpinner = false;
      dispatch('doSpinner', showSpinner, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* SAVE_ALBUMDETAIL */], { albumDetail: albumDetail });
    });
  },
  resetAlbumDetail: function resetAlbumDetail(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* RESET_ALBUMDETAIL */]);
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* SAVE_ALBULMS_LIST */], function (state, _ref4) {
  var albumsList = _ref4.albumsList;

  state.albumsList = albumsList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* SAVE_ALBUMDETAIL */], function (state, _ref5) {
  var albumDetail = _ref5.albumDetail;

  state.albumDetail = albumDetail;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* RESET_ALBUMDETAIL */], function (state) {
  state.albumDetail = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  namespaced: true
});

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_jsonholder__ = __webpack_require__(40);



var _mutations;




// initial state
var state = {
  postsList: [],
  postDetail: {},
  formData: {
    title: '',
    body: '',
    id: 1,
    userId: 1
  }
};

// getters
var getters = {
  allPosts: function allPosts(state) {
    return state.postsList;
  },
  postDetail: function postDetail(state) {
    return state.postDetail;
  }
};

// actions
var actions = {
  getPosts: function getPosts(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    __WEBPACK_IMPORTED_MODULE_3__services_jsonholder__["h" /* getPostsList */]().then(function (res) {
      var postsList = res.data.data;
      var showSpinner = false;
      dispatch('doSpinner', showSpinner, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* SAVE_POSTS_LIST */], { postsList: postsList });
    });
  },
  getPostDetail: function getPostDetail(_ref2, postId) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    __WEBPACK_IMPORTED_MODULE_3__services_jsonholder__["i" /* getPostDetail */](postId).then(function (res) {
      var showSpinner = false;
      var postDetail = res.data.data;
      var comments = [];
      __WEBPACK_IMPORTED_MODULE_3__services_jsonholder__["j" /* getPostComment */](postId).then(function (res) {
        comments = res.data.data;
        postDetail.comments = comments;
        dispatch('doSpinner', showSpinner, { root: true });
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* SAVE_POSTDETAIL */], { postDetail: postDetail });
      });
    });
  },
  resetDetail: function resetDetail(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* RESET_POSTDETAIL */]);
  }
  // updateDetail({ commit }, returnDetail) {
  //   commit(types.SAVE_POSTDETAIL, { postDetail: returnDetail });
  // }

};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* SAVE_POSTS_LIST */], function (state, _ref4) {
  var postsList = _ref4.postsList;

  state.postsList = postsList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* SAVE_POSTDETAIL */], function (state, _ref5) {
  var postDetail = _ref5.postDetail;

  console.log(postDetail);
  state.postDetail = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.postDetail, postDetail);
  state.formData = {
    title: postDetail.title,
    body: postDetail.body,
    id: postDetail.id,
    userId: postDetail.userId
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* RESET_POSTDETAIL */], function (state) {
  state.postDetail = {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'UPDATE_TITLE', function UPDATE_TITLE(state, title) {
  state.formData.title = title;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'UPDATE_BODY', function UPDATE_BODY(state, body) {
  state.formData.body = body;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  namespaced: true
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_jsonholder__ = __webpack_require__(40);


var _mutations;




// initial state
var state = {
  usersList: [],
  userDetail: {},
  userTodos: [],
  userPosts: [],
  userAblums: []
};

// getters
var getters = {
  allUsers: function allUsers(state) {
    return state.usersList;
  },
  userDetail: function userDetail(state) {
    return state.userDetail;
  },
  userTodos: function userTodos(state) {
    return state.userTodos;
  },
  userPosts: function userPosts(state) {
    return state.userPosts;
  },
  userAblums: function userAblums(state) {
    return state.userAblums;
  }
};

// actions
var actions = {
  getUsers: function getUsers(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    __WEBPACK_IMPORTED_MODULE_2__services_jsonholder__["a" /* getUsers */]().then(function (res) {
      var usersList = res.data.data;
      var showSpinner = false;
      dispatch('doSpinner', showSpinner, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SAVE_USERS_LIST */], { usersList: usersList });
    });
  },
  getUserDetail: function getUserDetail(_ref2, userId) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    __WEBPACK_IMPORTED_MODULE_2__services_jsonholder__["b" /* getUserDetail */](userId).then(function (res) {
      var userDetail = res.data.data;
      var showSpinner = false;
      dispatch('doSpinner', showSpinner, { root: true });
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SAVE_USERS_DETAIL */], { userDetail: userDetail });
    });
  },
  getUserTodoList: function getUserTodoList(_ref3, userId) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    __WEBPACK_IMPORTED_MODULE_2__services_jsonholder__["c" /* getUserTodoList */](userId).then(function (res) {
      var userTodos = res.data.data;
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SAVE_USERS_TODOS */], { userTodos: userTodos });
    });
  },
  getUserPostsList: function getUserPostsList(_ref4, userId) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    __WEBPACK_IMPORTED_MODULE_2__services_jsonholder__["d" /* getUserPostList */](userId).then(function (res) {
      var userPosts = res.data.data;
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SAVE_USERS_POSTS */], { userPosts: userPosts });
    });
  },
  getUserAlbumsList: function getUserAlbumsList(_ref5, userId) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    __WEBPACK_IMPORTED_MODULE_2__services_jsonholder__["e" /* getUserAlbumsList */](userId).then(function (res) {
      var userAblums = res.data.data;
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* SAVE_USERS_ABLUMS */], { userAblums: userAblums });
    });
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SAVE_USERS_LIST */], function (state, _ref6) {
  var usersList = _ref6.usersList;

  state.usersList = usersList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SAVE_USERS_DETAIL */], function (state, _ref7) {
  var userDetail = _ref7.userDetail;

  state.userDetail = userDetail;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SAVE_USERS_TODOS */], function (state, _ref8) {
  var userTodos = _ref8.userTodos;

  state.userTodos = userTodos;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SAVE_USERS_POSTS */], function (state, _ref9) {
  var userPosts = _ref9.userPosts;

  state.userPosts = userPosts;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* SAVE_USERS_ABLUMS */], function (state, _ref10) {
  var userAblums = _ref10.userAblums;

  state.userAblums = userAblums;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* RESET_USER_DETAIL */], function (state) {
  state.userDetail = {};
  state.userTodos = [];
  state.userPosts = [];
  state.userAblums = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  namespaced: true
});

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(19);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* SAVE_SHOWSPINNER */], function (state, showSpinner) {
  state.showSpinner = showSpinner;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* RESET_SHOWSPINNER */], function (state) {
  state.showSpinner = true;
}), _mutations);

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
  showSpinner: true
};

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_POSTS_LIST; });
/* unused harmony export SAVE_PHOTOS_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_ALBULMS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_ALBUMDETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RESET_ALBUMDETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SAVE_USERS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SAVE_SHOWSPINNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RESET_SHOWSPINNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_POSTDETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RESET_POSTDETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_USERS_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_USERS_TODOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_USERS_POSTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_USERS_ABLUMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESET_USER_DETAIL; });
/* unused harmony export RESET_USER_DETAIL_CHILDREN */
var SAVE_POSTS_LIST = 'SAVE_POSTS_LIST';
var SAVE_PHOTOS_LIST = 'SAVE_PHOTOS_LIST';
var SAVE_ALBULMS_LIST = 'SAVE_ALBULMS_LIST';
var SAVE_ALBUMDETAIL = 'SAVE_ALBUMDETAIL';
var RESET_ALBUMDETAIL = 'RESET_ALBUMDETAIL';
var SAVE_USERS_LIST = 'SAVE_USERS_LIST';
var SAVE_SHOWSPINNER = 'SAVE_SHOWSPINNER';
var RESET_SHOWSPINNER = 'RESET_SHOWSPINNER';
var SAVE_POSTDETAIL = 'SAVE_POSTDETAIL';
var RESET_POSTDETAIL = 'RESET_POSTDETAIL';
var SAVE_USERS_DETAIL = 'SAVE_USERS_DETAIL';
var SAVE_USERS_TODOS = 'SAVE_USERS_TODOS';
var SAVE_USERS_POSTS = 'SAVE_USERS_POSTS';
var SAVE_USERS_ABLUMS = 'SAVE_USERS_ABLUMS';
var RESET_USER_DETAIL = 'RESET_USER_DETAIL';
var RESET_USER_DETAIL_CHILDREN = 'RESET_USER_DETAIL_CHILDREN';

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 227:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-clip",
    style: (_vm.spinnerStyle)
  })])
},staticRenderFns: []}

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPostsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getPostDetail; });
/* unused harmony export updatePostDetail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getPostComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserTodoList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUserPostList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserAlbumsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAlbums; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAlbumDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_request__ = __webpack_require__(112);




var getPostsList = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_request__["a" /* default */])('/replace/posts');

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getPostsList() {
    return _ref.apply(this, arguments);
  };
}();

var getPostDetail = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_request__["a" /* default */])('/replace/posts/' + id);

          case 2:
            return _context2.abrupt('return', _context2.sent);

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getPostDetail(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var updatePostDetail = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(values) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_request__["a" /* default */])('/replace/posts/' + values.id, {
              method: 'PUT',
              data: values
            });

          case 2:
            return _context3.abrupt('return', _context3.sent);

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function updatePostDetail(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var getPostComment = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_request__["a" /* default */])('/replace/posts/' + id + '/comments');

          case 2:
            return _context4.abrupt('return', _context4.sent);

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function getPostComment(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

var getUsers = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_request__["a" /* default */])('/replace/users');

          case 2:
            return _context5.abrupt('return', _context5.sent);

          case 3:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function getUsers() {
    return _ref5.apply(this, arguments);
  };
}();

var getUserDetail = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_request__["a" /* default */])('/replace/users/' + userId);

          case 2:
            return _context6.abrupt('return', _context6.sent);

          case 3:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function getUserDetail(_x4) {
    return _ref6.apply(this, arguments);
  };
}();

var getUserTodoList = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_request__["a" /* default */])('/replace/users/' + userId + '/todos');

          case 2:
            return _context7.abrupt('return', _context7.sent);

          case 3:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function getUserTodoList(_x5) {
    return _ref7.apply(this, arguments);
  };
}();

var getUserPostList = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_request__["a" /* default */])('/replace/users/' + userId + '/posts');

          case 2:
            return _context8.abrupt('return', _context8.sent);

          case 3:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function getUserPostList(_x6) {
    return _ref8.apply(this, arguments);
  };
}();

var getUserAlbumsList = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_request__["a" /* default */])('/replace/users/' + userId + '/albums');

          case 2:
            return _context9.abrupt('return', _context9.sent);

          case 3:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function getUserAlbumsList(_x7) {
    return _ref9.apply(this, arguments);
  };
}();

var getAlbums = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_request__["a" /* default */])('/replace/albums');

          case 2:
            return _context10.abrupt('return', _context10.sent);

          case 3:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function getAlbums() {
    return _ref10.apply(this, arguments);
  };
}();

var getAlbumDetail = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_request__["a" /* default */])('/replace/albums/' + id + '/photos');

          case 2:
            return _context11.abrupt('return', _context11.sent);

          case 3:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function getAlbumDetail(_x8) {
    return _ref11.apply(this, arguments);
  };
}();

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

// 配置基本大小
var baseSize = 16;

// 设置 rem 函数
function setRem() {
  //当前页面宽度相对于1920px屏幕宽的缩放比例，可根据自己需要修改。
  var scale = (document.documentElement.clientWidth > 1200 ? 1200 : document.documentElement.clientWidth) / 330;
  //设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + "px";
}
setRem(); //初始化

// 适配 - 重置函数
function resetRem(num) {
  if (num) baseSize = Number(num);
  setRem();
}
window.resetRem = resetRem; // 全局可调用(其他方式也可)

// 改变窗口大小时重置 rem
window.onresize = function () {
  setRem();
};

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(242);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/home'
  }, {
    path: '/home',
    name: 'home',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 253));
    }
  }, {
    path: '/aiChineseMedicine/evaluation',
    name: 'aiChineseMedicineEvaluation',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 247));
    }
  }, {
    path: '/aiChineseMedicine/face',
    name: 'aiChineseMedicineFace',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 248));
    }
  }, {
    path: '/aiChineseMedicine/tongue',
    name: 'aiChineseMedicineTongue',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 252));
    }
  }, {
    path: '/aiChineseMedicine/inquiry',
    name: 'aiChineseMedicineInquiry',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 249));
    }
  }, {
    path: '/aiChineseMedicine/questionnaire',
    name: 'questionnaire',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 250));
    }
  }, {
    path: '/aiChineseMedicine/report',
    name: 'aiChineseMedicineReport',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 251));
    }
  }]
}));

/***/ })

},[157]);


// WEBPACK FOOTER //
// static/js/app.74a3353c7b69c1095a16.js